import React, { useEffect, useState } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./sections/About";
import Cta from "./sections/Cta";
import Hero from "./sections/Hero";
import WhyChoose from "./sections/WhyChoose";
import Contact from "./sections/Contact";
import "./App.css";
import WhatWeDo from "./sections/WhatWeDo";

export default function App() {
  const [activeSection, setActiveSection] = useState("hero");

  useEffect(() => {
    const handleScroll = () => {
      // Find the section that is currently in the viewport
      const sections = [
        "hero",
        "about",
        "why-us",
        "what-we-do",
        "cta",
        "contact",
      ];
      for (const sectionId of sections) {
        const section = document.getElementById(sectionId);
        if (section) {
          const rect = section.getBoundingClientRect();
          const windowHeight =
            window.innerHeight || document.documentElement.clientHeight;

          if (rect.top <= windowHeight / 2 && rect.bottom >= windowHeight / 2) {
            if (activeSection !== sectionId) {
              setActiveSection(sectionId);
            }
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up event listeners on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSection]);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);

    if (section) {
      const offset = (5 * window.innerHeight) / 100; // 5vh as an offset
      const sectionPosition =
        section.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top: sectionPosition,
        behavior: "smooth",
      });
    }
  };

  const [isHomePage, setIsHomePage] = useState(true);
  useEffect(() => {
    if (window.location.pathname === "/#" || window.location.pathname === "/") {
      setIsHomePage(true);
    } else {
      setIsHomePage(false);
    }
  }, [isHomePage]);
  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isHomePage]);

  return (
    <div className="App">
      <Header scrollToSection={scrollToSection} activeSection={activeSection} />

      <Hero />
      <About />
      {/* <Team /> */}
      <WhyChoose />
      <WhatWeDo />
      <Cta />
      <Contact />
      {/* <HowItWorks /> */}
      {/* <FAQ /> */}
      {/* <GetInTouch /> */}
      <Footer />
    </div>
  );
}
